import http from "../tools/http";

export default {
  getAll() {
    return http.get("/organizations");
  },
  getOne(orgUUID) {
    return http.get("/organizations/" + orgUUID);
  },
  update(data) {
    return http.patch(`/organizations/${data.uuid}`, data);
  },
  create(data) {
    return http.post(`/organizations`, data);
  },
  getSegments() {
    return http.get("/organization-segments");
  },
  getReport(orgUUID, filter) {
    return http.get("/organizations/" + orgUUID + "/report", { params: filter });
  },
  changeStatus(orgUUID, { activate, reason }) {
    return http.patch(`/organizations/${orgUUID}/activate`, { activate, reason });
  }
};
